import SettingsIcon from '@material-ui/icons/Settings';
import React from 'react';

export const Translate = {
    /********Specific*******/
    appName: "FIFA Best Coin",
    headLine: "Admin Management System",
    contents: "News",
    addContent: "Create News",
    viewContent: "View All News",
    makeContent: "Add News",
    publishContent: "Publish News",
    editContent: "Edit News",
    contentTitle: "News Title",
    contentAdded: "Your News created",
    contentAddingFailed: "There is a problem in making News",
    contentEdited: "Your news Edited",
    contentEditingFailed: "There is a problem in editing News",
    deleteContent: "News Removed",
    deleteContentFailed: "There is a problem in Removing News",
    thanks: "Thanks!",
    allPlatforms: "All Platforms!",
    choosePlatform: "Choose Platform",
    platformName: "Platform",
    pc: "PC",
    ps: "PS/XB",
    xbox: "XBOX One/XBOX Series",
    k: "K",
    chooseLanguage: "Choose Language",
    YouAreChangingThisLanguage: "You are changing this language",
    translateTable: "Translate Table",
    /*********Global**********/


    slug: "Slug",
    tags: "Tags",
    language: "Language",
    chooseColor: "Choose Color",
    account: "Account",
    viewMore: "View More",
    view: "Check out",
    male: "Male",
    female: "Female",
    time_duration: "Duration",
    value: "Value",
    gender: "Gender",
    payment_type: "Payment Method",
    addRow: "Add Row",
    manageProducts: "Products Management",
    manageSafeCoins: "Safe 3.0 Coins",
    managePlatforms: "Platforms Management",
    safecoins: "Safe 3.0 Coins",
    manageCurrencies: "Manage Currencies",
    currency_name: "Currency Name",
    priceEqualToOneDollar: "Price (=$1)",
    autoUpdateCurrencies: "Auto-Update Prices",
    currenciesUpdated: "Currencies Price Updated!",
    manageVariables: "Attributes Management",
    chooseVariables: "Choose Variable",
    makeVariable: "Make Variable",
    editVariable: "Edit variable",
    variableName: "Variable Name",
    variables: "Variables",
    variable: "Variable",
     makeOrder: "Add to cart",
    buyer: "Customer",
    totalPrice: "Total Price",
    editProduct: "Edit Product",
    productName: "Product name",
    productBio: "Brief description",
    productDescription: "Description",
    product: "Product",
    quantity: "quantity",
    viewProduct: "View Product",
    viewArticle: "View News",
    article: "News",
    viewOrders: "View Orders",
    viewUserDetails: "View User Details",
    manageOrders: "Orders Management",
    manageOrder: "Order Management",
    send: "Send",
    shopOrders: "Orders",
    products: "Products",
    productsList: "Products List",
    manageComments: "Comments Management",
    comments: "Comments",
    commentForReplayDescription : "Choose the Comment you want to answer!",
    description : "Description",
    noProduct:"No Product Found!",
    chooseProductForComment : "Choose Product",
    commentEdited:"Comment Edited!",
    commentAdded:"Comment Created!",
    commentAddingFailed:"There is a problem in creating comment.",
    commentEditingFailed:"There is a problem in editing comment.",
    commentRemoved: "Comment removed!",
    dataRemoved: "All information removed!",
    dataRemovingFailed: "There is a problem in removing information.",
    commentRemovingFailed: "There is a problem in removing comment.",
    deleteSelectedComments: "Selected comments removed!",
    deleteSelectedUsers: "Selected users removd!",
    role: "Role",
    allRoles: "All Roles",
    allUserTypes: "All users Type",
    editComment: "Edit Comment",
    addComment: "Add Comment",
    parentCommentDesc : "You are answering this comment:",
    confirmStatus:"Confirmation status",
    removeComment: "Remove Comment",
    translateFront: "Translations",
    translateFrontDesc: "If you made the changes by clicking the submit button and the changes were not seen in this section, check the website yourself.",
    thankYou: "Thank you!",
    settings: "Setting",
    exit: "Exit",
    myAccount: "Account",
    makeDraft: "Save Draft",
    userPanel: "Admin Panel",
    draft: "Draft",
    published: "Published",
    someFieldsHasError: "One or more fields have an error, please check them",
    search: "Search",
    author: "Author",
    choose: "Choose",
    updateTime: "Update Time",
    filters: "Filters",
    thumbnail: "Thumbnail ",
    publishStatus: "Publish status",
    keywordsLabel: "Keywords",
    similarWords: "عبارات مشابه",
    allKeywordsAreTyped: "امکان افزودن کلمات کلیدی بیشتر ندارید. ",
    keywordsDescription: "تگ‌های محصول خود را بنویسید. (برای مثال، طراحی مارکت پلیس، سئو کلاه سیاه و...)",
    seoDescription: "Brief Description",
    linkPlaceholder:"Insert a URL",
    addImage: "Add Image",
    imageName: "File name",
    ownerMedia:"Owner",
    linkCopied:"URL copied!",
    uploadSuccess: "Successfully Uploaded!",
    chooseFile:"Choose File",
    editFile:"Edited!",
    editFileFailed:"There is a problem in editing file!",
    tableAdded:"Table created",
    tableAddingFailed:"There is a problem in adding Table",
    deleteTable:"Table removed!",
    deleteTableFailed:"There is a problem in removing Table",
    tableEdited:"Table Edited",
    tableEditingFailed:"There is a problem in editing Table",
    selfFiles: "My Files",
    adminsFiles: "Admins Files",
    everyBodyFiles: "All Files",
    uploading: "Uploading...",
    uploadDone: "File Uploaded",
    allTypes: "All Formats",
    image: "Image",
    video: "Video",
    document: "Document",
    do: "Do it!",
    chooseVideo:"Choose video",
    multiImport:"Choose Files",
    filesTable: "Saved Files",
    fileManager: "File Manager",
    lastUpdate: "Last Update",
    userDetail: "User Details",
    usersManagement: "Users Management",
    paymentManagement: "Payments Management",
    allUsers: "View All users",
    usersActivity: "Users activities",
    addUser: "Add User",
    editUser: "Edit user",
    editDetails: "Edit Profile",
    logoSize600: "The appropriate size is 600x600px.",
    thumbnailSizeArticle: "The appropriate size is 1200x800px.",
    chooseMedia: "Choose Media",
    submitErrorFile:"The uploaded file has a problem.",
    imageSizeWidth700: "The appropriate width is 700px.",
    userAvatarSet:"Your profile picture has been updated.",
    profileImage: "Profile image",
    viewProfile: "View Profile",
    userAvatarSetFailed:"There is a problem in changing profile image",
    loadingThumbnailFailed: "There is a problem in loading Image",
    ChooseImageLink:" Click on Images to Copy their URL.",
    deleteFile:"File Removed!",
    deleteFileFailed:"There is problem with deleting file",
    deleteSelectedFiles:"Selected Files removed",
    alt: "Alt Text",
    chooseImage: "Choose Image",
    emptyImage: "Choose an Image",
    descriptionPlaceHolder: "Write content here...",
    words:"Words",
    characters:"Characters",
    uploadImage: "Upload",
    ThumbnailTitle: "Thumbnail",
    loading: "Loading...",
    login: "Login",
    homePage: "Home page",
    contactPage: "Support",
    shop: " Shop",
    orLoginWith: "Login with",
    backToHomePage: "Back to home page",
    emailOrMobile: "Email",
    first_name: "First Name",
    last_name: "Last name",
    username: "User name",
    userName: "Full name",
    mobile: "Mobile",
    mobileSample: "مثل 09123456789",
    email: "Email",
    profile: "Profile",
    verifyEmail: "Email Confirmation",
    password: "Password",
    comment: "Comment",
    passwordConfirm: "Pasword confirmation",
    passwordStrength:"At least 5 characters, including numbers and letters",
    passwordChanged:"Password Successfully changed!",
    currentPasswordError:"Current password is not correct",
    currentPassword:"Current password",
    register: "Register",
    dontHaveAccount: "Not registered?",
    haveAccount: "Are you registered?",
    loginError:"Email or Password is incorrect!",
    forgetPass:"Forgot your password?",
    loginWithToken:"ورود با رمز یکبار مصرف",
    dashboard:"Dashboard",
    emptyUsername: "نام کاربری خود را وارد کنید.",
    emptyTableCells: "Table is empty",
    wrongUsername: "User name is wrong",
    NotFreeUsername: "این نام کاربری قبلا انتخاب شده.",
    existEmail: "This email has already been taken!",
    existMobile: "این شماره موبایل قبلا ثبت شده.",
    emptyEmail: "Enter your email.",
    emptyMobile: "شماره موبایل خود را وارد کنید.",
    wrongEmail: "The email format is incorrect.",
    wrongMobile: "فرمت شماره موبایل اشتباه است.",
    wrongPrice: "Pricing is wrong",
    final_price: "Final Price",
    transferPrice: "هزینه ارسال",
    transfer_type: "نحوه ارسال",
    wrongSheba: "شماره شبا اشتباه است. (۲۴ عدد)",
    emptyPassword: "Enter your password",
    weakPassword: "Your password is weak!",
    notEqualPassword: "Passwords are not equal!",
    lessPost: "نوشته‌ی پست کم است",
    maxLength: "نوشته طولانی است",
    SelectFromSelect:"Choose",
    emptyField:'Field is empty',
    fillPrevFieldFirst:'ابتدا فیلد قبل را پر کنید.',
    emptyName: "Name is Required",
    emptyLastName: "نام خانوادگی ضروری است",
    noMatchPassword: "Password confirmation does'nt match!",
    emptyTagName:"نام برچسب ضروری است",
    emptyBrandName:"نام برند ضروری است",
    wrongCode:"شماره اشتباه است",
    wrongDate:"تاریخ اشتباه است",
    maxLength60:"The length of this field should not exceed 60 characters.",
    maxLength150:"The length of this field should not exceed 150 characters.",
    maxLength70:"The length of this field should not exceed 70 characters.",
    maxLength255:"The length of this field should not exceed 255 characters.",
    maxLength1000:"The length of this field should not exceed 1000 characters.",
    maxLength900:"The length of this field should not exceed 900 characters.",
    aboutText:"About Text",
    dear:"Dear",
    errorHappens:"An error occurred while loading the site!",
    allChangesSaved:"All changes Saved!",
    saveChanges:"Save changes",
    allChangesSavingFailed:"An error occurred",
    registerSuccess: "کاربر با موفقیت ثبت شد.",
    registerError: "خطا در ایجاد کاربر",
    cantLoadData:"There is a problem in loading data!",
    fileSizeWeak:"File Quality is low!",
    imageSize250kb:"Image size must be less than 250kb.",
    makingTokenError:"در ایجاد کد تایید مشکلی به وجود آمده است. ",
    youLoggedOff:"You are logged out of the admin panel!",
    mobileVerified:"شماره موبایل شما تایید شد.",
    wrongToken:"کد تایید اشتباه است. ",
    mobileVerify: "تایید موبایل",
    verifyMobile: "تایید شماره موبایل",
    sendTokenText1:"رمز یکبارمصرف شما به شماره",
    sendTokenText2:"ارسال شد.",
    sendTokenTextResend:"رمز یکبار مصرف مجددا برای شما ارسال شد.",
    sendTokenText3:"زمان باقی مانده تا ارسال مجدد پیامک",
    logOut: "Sign out",
    confirm: "Confirm",
    token:"کد تایید",
    forgetPassword: "فراموشی رمزعبور",
    invalidMobileNumber:"این شماره در سیستم وجود ندارد",
    recoverPassword:"بازیابی رمزعبور",
    recoverPasswordText:"برای بازیابی رمز عبور، شماره موبایل خود را وارد کنید.",
    sendAgain:"ارسال دوباره",
    changePassword: "Change Password",
    newPassword:"New Password",
    newPasswordConfirm:"New Password Confirmation",
    connectionError:'Your internet connection lost.',
    copyright: " All rights reserved. © ",
    unreadNotifications: "Unread Notifications",
    readNotifications: "Previous Notifications",
    noNotifications: "There is no Notification",
    nothingFound: "Nothing Found!",
    notFoundPage: "Nothing Found!",
    setDetails: "Set Details",
    save: "Save",
    detailsSet:"All Changes Saved.",
    detailsSetFailed:"There is a problem in saving data.",
    detailsGetFailed:"Data retrieval encountered.",
    mobilSample:"نمونه: 09121234567",
    confirmationStatus:"Status",
    contentConfirmationStatus:"کیفیت محتوا",
    confirmed:"Confirmed",
    unConfirmed:"Waiting",
    admin: "Admin",
    adminSmall: "Admin",
    supportUser: "Support",
    support: "Support",
    adminType: "Webmaster",
    normalType: "Other Users",
    usersLog: "Users Activities",
    someFieldsHasErrorPleaseCheckThem: "Some fields has Error please check them",
    duplicateName: 'این برند متعلق به شخص دیگری است.',
    dataAdded: "All changes Saved.",
    dataAddingFailed: "There is a problem in saving data.",
    dataEdited: "All changes Saved.",
    dataEditingFailed: "There is a problem in saving data.",
    deleteData: "All data removed!",
    youCantDeletePlatform: "You can't delete a Platform",
    deleteDataFailed: "Removing data failed",
    makeCategory: "Make Category",
    editCategory: "Edit Category",
    makePlatform: "Make Platform",
    editPlatform: "Edit Platform",
    categoryName: "Category Name",
    categoryParentName: "Parent Category",
    categories: "Categories",
    pleaseChooseCategoriesFirst: "Please select a category first!",
    category: "Category",
    chooseCategory: "Choose Category",
    chooseSubCategory: "Choose Sub-category",
    chooseMainCategory: "Choose Category",
    manageCategories: "Categories",
    manageTags: "Tags",
    tagName: "Tag name",
    makeTag: "Add Tag",
    editTag: "Edit Tag",
    managePages: "Pages Management",
    manageAbout: "About us page",
    manageOrderDescription: "Order Description",
    orderName: "Order",
    payment: "Payment",
    confirmStart: "Confirm Start",
    confirmCompleted: "Confirm Completed",
    manageHome: "Home page",
    manageTerms: "Privacy policy Page",
    manageContact: "Contact us",
    pageDetails: "Page Details",
    user: "User",
    realUser: "User",
    markAsRead: 'Mark as Read!',
    dataFetchingError: 'Error in Fetching Data!',
    activity: 'Activity',
    gallery: 'Gallery',
    removeImage: 'Remove Image',
    remove: 'Remove',
    removeRequest: 'Remove Request',
    discountMoreThanPrice:"Discount Price is more Main Price",
    discount_percent:"Discount Percent",
    discount_price:"Discount Price",
    discount:"Discount",
    factor:"Factor",
    bill:"Bill",
    price:"Price",
    coins_count:"Coins count",
    delivery_from:"Delivery from",
    delivery_to:"Delivery to",
    cancel:"Cancel!",
    youDontHavePermission:"You do not have authorized access!",
    pressEnterAfterEachKeyword:"پس از نوشتن هر عبارت دکمه Enter را بزنید!",
    addMoreKeywords:"مقاله باید بین ۳ تا ۵ عبارت کلیدی داشته باشد.",
    addCategories:"مقاله باید حداقل یک دسته‌بندی داشته باشد.",
    chooseBeginDate:"Start Date",
    chooseEndDate:"End date",
    chooseDate:"Choose Date",
    doFilter:"Filter",
    removeFilter:"Remove Filter",
    noLogFound:"No Log Found!",
    roleHelper:"Choose User Role",
    goBackToPanel:"Back to panel",
    emailVerified:"ایمیل تایید شد!",
    emailNotVerified:"ایمیل تایید نشد!",
    visitsChart:"نمودار بازدید‌ از پروفایل شما",
    googleAnalytics:"گوگل آنالیتیکس",
    liveUsers:"کاربران آنلاین",
    newProducts:"محصولات جدید",
    noProductsFound:"محصولی یافت نشد!",
    newShops:"فروشگاه‌های جدید",
    newRegistrations:"ثبت‌نام‌های جدید",
    todayAllUnRegisteredUsers:"بازدید‌های امروز",
    transactionType:"نوع تراکنش",
    depositMoney:"شارژ کیف پول",
    depositMoneyDescription:"مقدار مورد نظر برای شارژ کیف پول خود را در این قسمت وارد کنید.",
    withdrawMoney:"برداشت از کیف پول",
    withdrawMoneyDescription:"مقدار مورد نظر برای برداشت از کیف پول خود را در این قسمت وارد کنید.",
    deposit:"شارژ",
    withdraw:"برداشت",
    amount:"Price",
    status:"Status",
    not_payed:"Not Payed",
    waiting:"Account verification",
    has_error:"Error happened",
    selectErrorType:"Select error type",
    orderedProducts:"Products",
    start: "Processing Delivery",
    completed: "Completed",
    manage: "Manage",
    orderPayed:"مبلغ سفارش پرداخت شد.",
    orderPayingFailed:"در پرداخت مبلغ مشکلی وجود دارد!",
    pending:"Pending",
    myWallet: "کیف پول",
    fromWallet: "پرداخت از کیف پول",
    onlinePayment: "پرداخت آنلاین",
    orders: "Orders",
    orderSummary: "Order Summery",
    payOrder: "پرداخت از کیف پول",
    payOrderDetail: "در این بخش می‌توانید کیف پول خود را شارژ کنید و پرداخت را از طریق کیف پول انجام دهید.",
    payWithWallet: "پرداخت از کیف پول",
    purchase: "پرداخت",
    withdrawRequest: "درخواست واریز",
    transactionTrackingCode: "کد پیگیری",
    postal_code: "کد پستی",
    postalInfo: "اطلاعات پستی",
    pleaseCompleteYourPostalInfo: "لطفا اطلاعات پستی خود را تکمیل کنید!",
    postalInfoDescription: "لطفا اطلاعات پستی خود را در این قسمت وارد کنید، دکمه ثبت اطلاعات را بزنید و سپس اقدام به پرداخت کنید.",
    address: "آدرس",
    addRefrenceIdFirst: "ابتدا کد پیگیری را وارد کنید!",
    myWalletBalance: "موجودی کیف پول",
    myPoints: "امتیازات من",
    howToGetPoints: "آموزش نحوه امتیاز‌گیری",
    howToPay: "نحوه پرداخت",
    point: "امتیاز",
    point_title: "امتیاز",
    point_count: "تعداد",
    point_badge: "نماد",
    point_time: "زمان دریافت",
    congratulation: "تبریک!",
    getPoints: "امتیاز، دریافت کردید.",
    balance: "موجودی",
    pleaseVerifyFirst: "برای برداشت پول اطلاعاتتان را تکمیل کنید!",
    verificationDescription: "برای انجام تراکنش‌های آنلاین با سایت نیاز به تایید اطلاعات بانکی می‌باشد.",
    verificationDetails: "اطلاعات بانکی",
    verificationDataSets: "اطلاعات بانکی ثبت شد!",
    manageVerifications: "مدیریت اطلاعات بانکی",
    ManageUserVerification: "مدیریت اطلاعات بانکی کاربر",
    bank_name: "نام بانک",
    viewUserBankInfo: "مشاهده اطلاعات بانکی کاربر",
    sheba: "شماره شبا",
    activeStatus: "وضعیت",
    active: "فعال",
    deactive: "غیر فعال",
    manageWallets: "مدیریت کیف پول‌ها",
    manageUserWallet: "مدیریت تراکنش‌های کاربر",
    yourBankInfoIsActive: "اطلاعات بانکی شما تایید شده و امکان انجام تراکنش برای شما فراهم است.",
    yourBankInfoIsInchecking: "اطلاعات بانکی شما در دست بررسی است.",
    payed: "payed",
    is_payed: "Payed",
    areYouSure: "Are you sure to do this?",
    yes: "Yes",
    no: "No",
    deleteIt: "Delete",
    originEmail: "Origin Email",
    originPassword: "Origin Password",
    current_coin_amount: "Current coin amount",
    backup_codes: "Backup Codes",
    nologinverification: "No login verification",
    marketlocked:"Market locked",
    wrongpassword: "Wrong password",
    wrongbackup: "Wrong backup",
    submitError: "Submit Error",
    statusChanges: "Order status changed!",
    AddTable : "Create a Table",
    EditTable : "Edit Table",
    TableBuilder:"Table Builder",
    tableName: "Table name",
    makeTable: "Create Table",
    chooseTableStructure:"Choose Table Columns and Rows",
    columns:"Columns",
    rows:"Rows",
    addRows:"Add Row",
    addColumns:"Add Column",
    buildTable:"Build Table",
    withHeading:"Table With Heading",
    withoutHeading:"Tale Without Heading",
    tableTdPlaceholder:"Type your Content...",
    CodeBuilder:"HTML code",
    AddCode : "Add HTML",
    EditCode : "Edit HTML",
    codeName: "HTML code name",
    makeCode: "Create HTML code",
    codeAdded:"HTML code created",
    codeAddingFailed:"There is a problem in adding HTML code",
    deleteCode:"HTML code removed!",
    deleteCodeFailed:"There is a problem in removing HTML code",
    codeEdited:"HTML code Edited",
    codeEditingFailed:"There is a problem in editing HTML code",
    htmlCode:"HTML code",
};

export const DataTableLocalization = {
    header: {
        actions: <SettingsIcon/>
    },

};
